import CONSTANTS from '../constants';
import OrderTypeHelper from './OrderTypeHelper';

export default class OrderHelper {
  static isPlaced(status) {
    return status && status.status_name === CONSTANTS.ORDERS.VARIABLES.STATUSES.PLACED;
  }

  static isSeen(status) {
    return status && status.status_name === CONSTANTS.ORDERS.VARIABLES.STATUSES.SEEN;
  }

  static isCompleted(status) {
    return status && status.status_name === CONSTANTS.ORDERS.VARIABLES.STATUSES.COMPLETE;
  }

  static isCancelled(status) {
    return status && status.status_name === CONSTANTS.ORDERS.VARIABLES.STATUSES.CANCELLED;
  }


  static allowedStatusIds(orderType) {
    if (OrderTypeHelper.isDineIn([], orderType))
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPE_STATUSES.DINE_IN;
    if (OrderTypeHelper.isDelivery([], orderType)) {
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPE_STATUSES.DELIVERY;
    }
    if (OrderTypeHelper.isPickup([], orderType))
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPE_STATUSES.PICK_UP;
    if (OrderTypeHelper.isCurbsidePickup([], orderType))
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPE_STATUSES.CURBSIDE_PICKUP;
  }

  static allowedStatuses(orderType, statuses) {
    if (!orderType) return statuses;

    let statusIds = this.allowedStatusIds(orderType.order_type);
    return statuses.filter((status) => statusIds.includes(status.status_id));
  }

  static makeCreateOrderDto(userId, qrData, qrCodeData, cartData, orderData, paymentData = null) {
    const menuItems = cartData.order_data.map((item) => {
      const option_value_ids = item.options && item.options.map((option) => option.option_value_id);
      const menuOptionValueIds = new Set();
      const optionValueIds = new Set();

      const allMenuOptionsValues = [];
      const allOptionValues = [];
      const menuOptions = item.MenuOptions;

      menuOptions.forEach((menuOption) => {
        menuOption.MenuOptionValues.forEach((menuOptionValue) => {
          if (!menuOptionValueIds.has(menuOptionValue.menu_option_value_id)) {
            menuOptionValueIds.add(menuOptionValue.menu_option_value_id);
            allMenuOptionsValues.push(menuOptionValue);
          }
        });
        menuOption.Option_Values.forEach((optionValue) => {
          if (!optionValueIds.has(optionValue.option_value_id)) {
            optionValueIds.add(optionValue.option_value_id);
            allOptionValues.push(optionValue);
          }
        });
      });

      const menu_options_arr = [];
      const addedMenuOptions = new Set();

      allMenuOptionsValues.forEach((menuOptionValue) => {
        if (option_value_ids.includes(menuOptionValue.option_value_id)) {
          if (!addedMenuOptions.has(menuOptionValue.menu_option_value_id)) {
            menu_options_arr.push({
              id: menuOptionValue.menu_option_value_id,
              count: allOptionValues.find(
                (ov) => ov.menu_option_value_id === menuOptionValue.menu_option_value_id
              ).optionCount
            });
            addedMenuOptions.add(menuOptionValue.menu_option_value_id);
          }
        }
      });

      return {
        menu_id: item.menu_id,
        menu_option_values: [...menu_options_arr],
        item_count: item.itemCount,
        isRewardItem: item.isRewardItem,
        comment: item.comment,
        ...(item.portionSize ? { portion_size_id: item.portionSize.portion_size_id } : {})
      };
    });

    const [lat, lng] = orderData.delivery_location
      ? orderData.delivery_location.split(',')
      : [0, 0];

    const postData = {
      user_id: userId,
      menu_items: menuItems,
      delivery_location: {
        lat,
        lng
      },
      delivery_address: orderData.delivery_address,
      delivery_phone: orderData.delivery_phone,
      car_number: orderData.car_number,
      car_model: orderData.car_model,
      order_time: orderData.order_time,
      order_date: orderData.order_date,
      order_type_id: orderData.order_type_id,
      comment: orderData.comment,
      qrcode: qrData,
      qrcodedata: qrCodeData,
      promocode_id: cartData.discount_id,
      bindiscount_id: cartData.bindiscount_id,
      whatsapp_order: cartData.whatsapp_order,
      platform: orderData.platform,
      isRewardOrder: orderData.isRewardOrder,
      rewardDiscount: orderData.rewardDiscount,
      cardPaymentOrder: cartData.cardPaymentOrder,
      platform: orderData.platform,
      savyour_order: orderData.savyour_order,
      address_id: orderData.address_id
    };
    return postData;
  }
}
